import React, { useState, useEffect } from 'react'
import I18n from 'i18n'
import { MyAxios as axios } from '../../MyAxios'
import { WithQuestionnaires } from '../../questionnaires/QuestionnaireProvider'
import { WithFlashMessages } from '../../flashmessages/FlashMessageProvider'
import Spinner from '../../common/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { questionnaireName } from '../../common/Utils'

const QuestionnaireDefinitions = (props) => {
  const [questionnaires, setQuestionnaires] = useState(undefined)
  const [downloading, setDownloading] = useState(false)

  useEffect(() => {
    axios({
      method: 'GET',
      url: props.questionnaires.questionnaireDefinitionsUrl(),
      headers: props.questionnaires.authenticatedHeaders()
    }).then((response) => {
      setQuestionnaires(response.data)
    }).catch((err) => {
      setQuestionnaires([])
      console.log('Error retrieving questionnaires')
      console.log(err)
    })
  }, [])

  const downloadDefinition = (questionnaireKey) => {
    setDownloading(true)
    props.questionnaires.downloadQuestionnaireDefinition(questionnaireKey).catch(() => {
      props.flashMessages.push(
        I18n.t('group.detail.questionnaires.download_questionnaire_definition_error'),
        props.flashMessages.duration.LONG,
        props.flashMessages.levels.ERROR
      )
    }).finally(() => setDownloading(false))
  }

  if (!questionnaires) {
    return <Spinner transparent />
  }

  return (
    <div className='row'>
      <div className='download-definitions col s12'>
        {
          questionnaires.map(questionnaire => (
            <button
              type='button'
              key={questionnaire.key}
              style={{ marginRight: '1rem' }}
              id='download-definition-button'
              disabled={downloading}
              className='data-button data-detail-page waves-effect waves-light background-background button-primary text-primary-color wider-data-button text-medium text-m'
              onClick={() => downloadDefinition(questionnaire.key)}
            >
              <FontAwesomeIcon className='button-icon' icon='file-download' />
              {questionnaire.title || questionnaireName(questionnaire.key)}
            </button>
          ))
        }
        {questionnaires.length === 0 &&
          <p className='text-muted'>{I18n.t('group.detail.questionnaires.no_available_questionnaire_definitions')}</p>}
      </div>
    </div>
  )
}

export default WithFlashMessages(WithQuestionnaires(QuestionnaireDefinitions))
